export class BaseResponse<T> {
    count?:number;
    message?: string;
    link?: string;
    items?: Array<T>;
    value?: T;
    errors?: [string, string[]][];
    success:boolean;

    constructor(success: boolean, message: string, value: T) {
        this.success = success;
        this.message = message;
        this.value = value;
    }
}
